module.exports = __webpack_public_path__ + "static/img/son2.91e96de3.png";